import axios from "axios";

// USER START MANAGEMENT
export async function requestGetUserList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/users?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestCreateUser(payload) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/users/add`, payload);
}

export async function requestGetUserDetail(id) {
	return await axios.get(`${import.meta.env.VITE_API_URL}/admin/users/${id}`);
}

export async function requestUpdateUser(id, payload) {
	return await axios.put(`${import.meta.env.VITE_API_URL}/admin/users/${id}/edit`, payload);
}
// USER MANAGEMENT END

// SHOP MANAGEMENT START
export async function requestGetShopList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/shops?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}

export async function requestVerifyShop(id) {
	return await axios.post(`${import.meta.env.VITE_API_URL}/admin/shops/${id}/verify`);
}
// SHOP MANAGEMENT END

// PRODUCT MANAGEMENT START
export async function requestGetProductList({
	page = 1,
	limit = 10,
	order = "_id:desc",
	keyword = "",
	filter = "",
}) {
	return await axios.get(
		`${
			import.meta.env.VITE_API_URL
		}/admin/products?page=${page}&limit=${limit}&keyword=${encodeURIComponent(
			keyword
		)}&filter=${filter}&order=${order}`
	);
}
// PRODUCT MANAGEMENT END
